import React, {useEffect, useRef} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ReplayIcon from '@mui/icons-material/Replay';

import {setLayoutHistory} from "../../../../actions/actionFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {getCurrentLayout} from "../../../appLayout";
import {updateNavigationCount} from "../../../../actions/lookFunctions";
import {LOOK_INTRO_STEPS_MOBILE} from "../../core/constants";
import LookIntroPopper from "../lookIntro/lookIntroPopper";

const LookSideBarRevertButton = (props) => {

  const {intl, popupCloseClick, disabled, layoutHistory, setLayoutHistory, updateNavigationCount, updateLookCartItem,
    isMobile, showRoomLayoutsButton, introStep} = props;
  const anchorRef = useRef(null);

  const neededIntroStep = LOOK_INTRO_STEPS_MOBILE.layouts;

  const undoButtonClick = () => {
    if (popupCloseClick) {
      popupCloseClick();
    }
    if (layoutHistory.length <= 1) {
      return false
    }
    const layout = getCurrentLayout();
    layoutHistory.pop(); // removes the last element from array
    const lastState = layoutHistory[layoutHistory.length - 1]; // take last state after deleting!
    layout.setActiveFeaturesFromObject(lastState);

    updateNavigationCount();
    updateLookCartItem();
    setLayoutHistory(layoutHistory);
  }

  const keyboardDetect = (event) => {
    if (event.ctrlKey && event.key === 'z') {
      Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarRevertCtrlZ);
      undoButtonClick()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', keyboardDetect);
    return () => {
      document.removeEventListener('keydown', keyboardDetect)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const realDisabled = disabled || layoutHistory.length <= 1;

  const button = (
    <IconButton aria-label={intl.formatMessage({id:"tooltip.revert"})}
                disabled={realDisabled}
                ref={anchorRef}
                className={"look-icon look-sidebar__button"
                  + (isMobile && !showRoomLayoutsButton && (introStep === neededIntroStep)
                    ? " look-sidebar__button--intro" : "")}
                onClick={() => {
                  Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarRevertCtrlZ);
                  undoButtonClick();
                }}>
      <ReplayIcon/>
    </IconButton>
  );

  return (
    <li className={"look-sidebar__list-item"}>
      {realDisabled ? button : (
        <Tooltip title={intl.formatMessage({id:"tooltip.revert"})} placement="right">
          {button}
        </Tooltip>
      )}
      {isMobile && !showRoomLayoutsButton
        ? <LookIntroPopper anchorRef={anchorRef}
                           currentStep={neededIntroStep}
                           toolTipText={"look.intro.step2.mobile.revert.title"}/> : null}
      {/*<span className="look-tooltip"><FormattedMessage id="tooltip.filters"/></span>*/}
    </li>
  )
};

const mapStateToProps = (store) => {
  const {layoutHistory} = store.historyState;
  const {isMobile} = store.serverState;
  const {introStep} = store.lookState;

  return {
    layoutHistory,
    isMobile,
    introStep,
  };
};

const mapDispatchToProps = {
  setLayoutHistory,
  updateNavigationCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookSideBarRevertButton)
)
